'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import * as FileApi from 'fileapi';

import tpl_customWebpageInsert from './tpl/customWebpageInsert.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import * as Entities_Empty from '../../../lib/entities/empty';

import config from '../../../common/config';

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_customWebpageInsert();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    ui: {
        'customWebpageInsert_btnSubmit': '#customWebpageInsert_btnSubmit',
        'customWebpageInsert_inputName' : '#customWebpageInsert_inputName',
        'customWebpageInsert_labelName' : '#customWebpageInsert_labelName'
    },
    events: {
        'click @ui.customWebpageInsert_btnSubmit': 'btnSubmitClick'
    },
    onRender: function () {
        switch (this.model.attributes.DisplayType)  {
            case 0 :
                this.ui.customWebpageInsert_labelName.text(resources.X100135);
                break;
            case 1 :
                this.ui.customWebpageInsert_labelName.text(resources.X100452);
                break;
        }
    },
    btnSubmitClick: function () {
        this.hideErrors();
        var tmpModel = new this.app.entities.collections.customWebpage.model();
        //tmpModel.attributes.id = null;
        tmpModel.attributes.AuthUserId = config.authUserId();
        tmpModel.attributes.DisplayType = this.model.attributes.DisplayType;
        tmpModel.attributes.Name = this.ui.customWebpageInsert_inputName.val();
        tmpModel.attributes.CustomWebpage_Header = resources.X100137;
        tmpModel.attributes.CustomWebpage_BodyIndex = resources.X100138;
        tmpModel.attributes.CustomWebpage_Footer = resources.X100139;
        tmpModel.attributes.CustomWebpage_Info = resources.X100140;
        tmpModel.attributes.CustomWebpage_Poster = resources.X100141;
        tmpModel.attributes.CustomWebpage_ImagePrint = resources.X100142;
        tmpModel.attributes.CustomWebpage_Schema = resources.X100143;
        tmpModel.attributes.CustomWebpage_SchemaBigscreen = resources.X100506;
        tmpModel.attributes.CustomWebpage_ProductSheet = resources.X101138;
        tmpModel.attributes.CustomWebpage_QR = resources.X101230;
        tmpModel.attributes.CustomWebpage_Location = resources.X101231;
        tmpModel.attributes.CustomWebpage_Calendar = resources.X101234;
        tmpModel.attributes.CustomWebpage_Form = resources.X100144;

        var ret = tmpModel.validateNoBackbone(this.app);
        if (ret == false) {
            var themeModel = this.app.entities.collections.paintStrap.fullCollection.where({ Default: true });

            if (themeModel.length > 0) {
                tmpModel.attributes.Theme = themeModel[0].attributes.id;
                tmpModel.attributes.CssFile = themeModel[0].attributes.CssFile;
                tmpModel.attributes.CssUpdate = false;

                var self = this;

                var dialogWaitingModel = new Entities_Empty.Model();
                dialogWaitingModel.attributes.Title = resources.X100134;
                dialogWaitingModel.attributes.Text = resources.X100309;
                dialogWaitingModel.attributes.Button = resources.X100279;

                var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: this });
                var callback = function (options) {
                    this.stopListening(dialogWaiting, "dialog:okclicked", callback);
                }
                this.listenTo(dialogWaiting, "dialog:okclicked", callback);
                this.app.dialogRegion.show(dialogWaiting);

                var file = file = themeModel[0].attributes.CssFile;

                var callback = function() {
                    self.app.entities.collections.customWebpageItem.fetch({
                        silent : true,
                        wait: true,
                        cache: false,
                        success: function (mode, response) {
                            //alert("read ok");
                        },
                        error: function (mode, response) {
                            //alert("read not ok");
                        }
                    });
                }

                $.when($.get(file))
                    .done(function (response) {
                        tmpModel.attributes.CssUpdate = true;
                        tmpModel.attributes.CssData = response;

                        self.collection.fullCollection.create(tmpModel, {
                            success: function (response) {
                                dialogWaiting.triggerMethod('dialog:close');
                                self.collection.fullCollection.sort();
                                self.collection.getFirstPage({ fetch: false });

                                self.ui.customWebpageInsert_inputName.val('');

                                //reread webpage item
                                //self.app.entities.collections.customWebpageItem.fetch({
                                //    silent : true,
                                //    wait: true,
                                //    success: function (mode, response) {
                                //        alert("read ok");
                                //    },
                                //    error: function (mode, response) {
                                //        alert("read not ok");
                                //    }
                                //});

                                //alert("callback");
                                callback();

                                var i = 0;
                            }
                        });

                        self.ui.customWebpageInsert_inputName.val('');
                    });
            }
        }
        else {
            this.showErrors(tmpModel.errors);
        }
    }
});